<form [formGroup]="formGroup" (ngSubmit)="submitFormV2()" (keydown.enter)="$event.preventDefault()">
  <formly-form [form]="formGroup" [fields]="fields" [model]="formModel"></formly-form>

  <div class="v2-mt-5 d-flex justify-content-end">
    <button-v2 (click)="hideModal.emit()" class="v2-mr-2" type="secondary">Cancel</button-v2>

    <button-v2 [disabled]="!formGroup?.valid" formButtonState buttonType="submit"
      >Confirm & Assign</button-v2
    >
  </div>
</form>
